import { AiAssistantPageSource, aiAssistantPageSource, routes } from '../constants';

/**
 * Determines the page source for AI Assistant tracking events based on the current pathname.
 *
 * @param pathname - The current browser pathname
 * @returns 'reader' if on the reader page, 'mukibude' for the AI Tools page
 */
export const getAIAssistantPageSource = (pathname: string): 'reader' | 'mukibude' => {
  return pathname.startsWith(`/${routes.reader.root}/`) ? 'reader' : 'mukibude';
};

const isKnownAIAssistantPageSource = (value: string): value is AiAssistantPageSource =>
  (Object.values(aiAssistantPageSource) as string[]).includes(value);

/**
 * Resolves the AI Assistant page source with link propagation taking precedence
 * over the pathname fallback: a Muki dashboard card stamps `dashboard` into the
 * /ki-tools link (state for same-tab, query for new tab), so the opened event
 * attributes to the dashboard; any direct visit still falls back to the
 * pathname-derived value. The query param is a system boundary — unknown values
 * are ignored, not sent to Amplitude.
 */
export const resolveAIAssistantPageSource = (
  pathname: string,
  state: unknown,
  query?: { page_source?: string },
): AiAssistantPageSource => {
  const fromState = (state as { pageSource?: AiAssistantPageSource })?.pageSource;
  if (fromState && isKnownAIAssistantPageSource(fromState)) return fromState;
  const fromQuery = query?.page_source;
  if (fromQuery !== undefined && isKnownAIAssistantPageSource(fromQuery)) return fromQuery;
  return getAIAssistantPageSource(pathname);
};
